import { highArmorPagesColumn } from "../resource/high-armor-pages-column";
import { NeededColumn } from "./needed-column";

export const highArmorPageNeededColumn = new NeededColumn(
  "c95ed524-8223-4efc-95d3-c7491a8bffc3",
  highArmorPagesColumn,
  "Purp Page Needed"
)
